var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16044 5.06472L14.1645 1.07339C14.4276 0.987913 14.7093 0.97687 14.9783 1.04148C15.2474 1.10609 15.4933 1.24383 15.689 1.43949C15.8846 1.63514 16.0224 1.88108 16.087 2.15013C16.1516 2.41918 16.1406 2.70085 16.0551 2.96402L12.0638 14.968C11.9651 15.2682 11.7741 15.5296 11.5182 15.7149C11.2622 15.9002 10.9543 16 10.6383 16C10.3223 16 10.0143 15.9002 9.75837 15.7149C9.5024 15.5296 9.31147 15.2682 9.2128 14.968L7.7123 10.4665C7.63901 10.2422 7.51386 10.0384 7.347 9.8715C7.18014 9.70464 6.97628 9.57949 6.75198 9.50621L2.25047 8.0057C1.9086 7.94793 1.59728 7.77354 1.36945 7.51219C1.14161 7.25084 1.01131 6.91865 1.0007 6.57209C0.990094 6.22554 1.09983 5.886 1.31125 5.6112C1.52268 5.3364 1.82274 5.1433 2.16044 5.06472Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).b32331e56f5fbcd19a5bcbaf26ef7feb.svg";
export { ForwardRef as ReactComponent };